import React from 'react';
import {Drawer} from 'shared/ui/Drawer';
import {Button} from 'ui';

export interface SignAcceptanceDrawerProps {
	open: boolean;
	onClose: () => void;
	acceptanceUri?: string | null;
	acceptanceCertificateUri?: string | null;
	onOpenAcceptance: () => void;
	onSignAcceptance: () => void;
}

export function SignAcceptanceDrawer({
	open,
	onClose,
	acceptanceUri,
	acceptanceCertificateUri,
	onOpenAcceptance,
	onSignAcceptance,
}: SignAcceptanceDrawerProps): React.ReactElement {
	return (
		<Drawer
			open={open}
			onClose={onClose}
			title="Подпишите акт"
			footerContent={
				<Button
					type="button"
					className="!w-full !h-[60px]"
					onClick={onSignAcceptance}
					disabled={!acceptanceCertificateUri}
				>
					Подписать акт
				</Button>
			}
		>
			<p className="text-black/55 mb-6">
				Если вы выполнили заказ, подпишите акт выполненных работ и ожидайте подтверждения со стороны заказчика
			</p>

			<button
				type="button"
				onClick={onOpenAcceptance}
				disabled={!acceptanceUri}
				className="w-full flex items-center justify-between bg-white pl-4 py-2 pr-2 cursor-pointer rounded-r-full disabled:opacity-50 disabled:cursor-not-allowed"
			>
				<div className="text-black font-medium">Акт выполненных работ</div>
				<div className="w-16 h-16 rounded-full bg-[#F3F3F3] flex items-center justify-center">
					<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M19 2V9H26L19 2Z" fill="black" />
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M17.1111 2V11H26V30H6V2H17.1111ZM9 16H23V18H9V16ZM23 21H9V23H23V21Z"
							fill="black"
						/>
					</svg>
				</div>
			</button>
		</Drawer>
	);
}
